(function() {
    /* globals $, angular */
    'use strict';

    angular.module('dashboardApp').controller('logoutController', Controller);
    Controller.$inject = [
        '$cookies',
        'Login',
        'Routing'
    ];

    function Controller (
        $cookies,
        Login,
        Routing
    ) {



        function logout() {
            
            Login.logout().then(function() {
                Routing.start();
            }).catch(function() {
                Routing.login();
            });
        }

        logout();
        
    }



})();
